module.exports = __webpack_public_path__ + "static/media/brand-status-image.4760dd24.png";